import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  hasAgreed = false;

  constructor(private location: Location, private router: Router) {
  }

  ngOnInit() {
  }

  recordAgreement(): void {
    this.hasAgreed = true;
    this.router.navigate(['/cases']);
  }

  goBack(): void {
    this.location.back();
  }
}
